/* eslint-disable */
import { useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../asset/css/pop.css";
import i_close from "../../asset/images/icon_x.png";
import emailjs from "@emailjs/browser";

const variants = {
  visible: { opacity: 1 },
  hidden: { opacity: 0 },
};

export default function DemoModal({ demoModal, setDemoModal }) {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm("service_itayvyv", "template_9ke1wy6", form.current, "zHCljDADvP6xTuvpa").then(
      (result) => {
        alert("Success Send Email!");
        form.current.reset();
      },
      (error) => {
        console.log(error.text);
        alert("이메일이 전송이 실패되었습니다.");
      },
    );
  };

  return (
    <div className="pop">
      <div className="pop_dim" onClick={() => setDemoModal(false)} />
      <motion.div className="pop_container" initial="hidden" animate="visible" variants={variants}>
        <div className="close" onClick={() => setDemoModal(false)}>
          <img src={i_close} />
        </div>
        <span className="pop_title">Request Demo</span>

        <form className="cs_input_container_pop" ref={form} onSubmit={sendEmail}>
          <div className="cs_input1">
            <div className="cs_input_box">
              <span>Name*</span>
              <motion.input
                whileFocus={{ scale: 1.05 }}
                autoComplete="none"
                style={{ border: "2px solid #020202" }}
                name="name"
                required
              />
            </div>
          </div>
          <div className="cs_input2" style={{ gap: "0px" }}>
            <div className="cs_input_box" style={{ marginRight: "5px", width: "49%" }}>
              <span>Company*</span>
              <motion.input
                autoComplete="none"
                whileFocus={{ scale: 1.05 }}
                name="company"
                required
                style={{ border: "2px solid #020202" }}
              />
            </div>
            <div className="cs_input_box">
              <span>Department</span>
              <motion.input
                whileFocus={{ scale: 1.05 }}
                autoComplete="none"
                name="department"
                style={{ border: "2px solid #020202" }}
              />
            </div>
          </div>
          <div className="cs_input2" style={{ gap: "0px" }}>
            <div className="cs_input_box" style={{ marginRight: "5px", width: "49%" }}>
              <span>Business E-mail*</span>
              <motion.input
                whileFocus={{ scale: 1.05 }}
                name="email"
                type="email"
                required
                style={{ border: "2px solid #020202" }}
              />
            </div>
            <div className="cs_input_box">
              <span>Phone number</span>
              <motion.input
                whileFocus={{ scale: 1.05 }}
                autoComplete="none"
                name="phone"
                style={{ border: "2px solid #020202" }}
              />
            </div>
          </div>
          <div className="cs_input4">
            <div className="cs_input_box">
              <span>Message</span>
              <motion.textarea
                rows="10"
                autoComplete="none"
                whileFocus={{ scale: 1.05 }}
                name="memo"
                style={{ border: "2px solid #020202" }}
              />
            </div>
          </div>
          <div className="cs_submit" style={{ justifyContent: "center" }}>
            <motion.button
              type="submit"
              className="cs_submit_btn"
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
            >
              Send email
            </motion.button>
          </div>
        </form>

        {/* <div className="cs_input_container_pop">
          <div className="cs_input1">
            <div className="cs_input_box">
              <span>Name*</span>
              <input />
            </div>
          </div>
          <div className="cs_input2" style={{ gap: "0px" }}>
            <div className="cs_input_box">
              <span>Company*</span>
              <input />
            </div>
            <div className="cs_input_box">
              <span>Department</span>
              <input />
            </div>
          </div>
          <div className="cs_input2" style={{ gap: "0px" }}>
            <div className="cs_input_box" style={{ marginRight: "5px", width: "49%" }}>
              <span>Business E-mail*</span>
              <input />
            </div>
            <div className="cs_input_box">
              <span>Phone number</span>
              <input />
            </div>
          </div>
          <div className="cs_input4">
            <div className="cs_input_box">
              <span>Message</span>
              <textarea rows="10" className="pop_textarea" />
            </div>
          </div>
          <div className="cs_submit">
            <motion.a
              className="cs_submit_btn_pop"
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
              href={`mailto:mjesun1@naver.com?subject=호호&body=${new Date()}%0D%0A내용이다`}
            >
              Send mail
            </motion.a>
          </div>
        </div> */}
      </motion.div>
    </div>
  );
}
